import { useDarkMode } from "@/hooks/use-dark-mode";

interface AuthLogoProps {
  className?: string;
}

export function AuthLogo({ className = "h-12" }: AuthLogoProps) {
  const dark = useDarkMode();
  return (
    <img
      src={dark ? "/nashid-logo-dark.png" : "/nashid-logo-blue.png"}
      alt="Nashid"
      className={className}
    />
  );
}
